import React from "react";
import PropTypes from "prop-types";

const HierarchyTreeIcon = ({ plus, ...props }) => (
  <span {...props}>
    <svg width="16px" viewBox="0 0 17 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter filterUnits="objectBoundingBox" id="filter-1">
          <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.299365942 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g id="UI-/-SYMBOLS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="_CARDS/TABLE/HIERARCHY/UI-Entry-Selected" transform="translate(1.000000, 2.000000)">
          <g id="UI/INPUT/UI-CHECK_-">
            <g filter="url(#filter-1)">
              <rect
                id="Rectangle-33"
                stroke="#ED7630"
                fill="#FFFFFF"
                x="-0.5"
                y="-0.5"
                width="16"
                height="16"
                rx="2"
              />
              <rect id="Rectangle-2" fill="#ED7630" x="2" y="6.5" width="11" height="2" />
              {plus && (
                <rect
                  id="Rectangle-2"
                  fill="#ED7630"
                  transform="translate(7.000000, 7.000000) rotate(90.000000) translate(-8.000000, -8.000000) "
                  x="3"
                  y="6.5"
                  width="11"
                  height="2"
                />
              )}
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
);

HierarchyTreeIcon.propTypes = {
  plus: PropTypes.bool,
};

export default HierarchyTreeIcon;
